import React, { memo } from "react"
import { Box } from "@material-ui/core"

const FlexBox = ({ alignItems = "center", children, ...rest }) => (
  <Box display="flex" alignItems={alignItems} {...rest}>
    {children}
  </Box>
)

const FlexBoxMemo = memo(FlexBox)

export { FlexBoxMemo as FlexBox }
